import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navLightColor = 'rgba(124, 58, 237, 0.15)';

  const navLight = {
    backgroundColor: navLightColor,
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      style={navLight}
      className={`fixed w-full z-50 transition-all duration-500 ease-in-out ${
        isScrolled ? 'scroll backdrop-blur-sm shadow-lg' : 'default'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-10">
          <button
            onClick={() => window.location.reload()}
            className="text-white font-bold"
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
          >AS</button>
          <div className="nav-links" style={{ display: "flex", gap: "32px" }}>
            {[["Work", "work"], ["Skills", "skills"], ["Contact", "contact"]].map(([label, id]) => (
              <button
                key={id}
                onClick={() => scrollTo(id)}
                className="nav-link"
                style={{ background: "none", border: "none", cursor: "pointer" }}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;